import React from 'react';
import styles from './Select.module.scss';
/** Native select dropdown. */ export const Select = ({ value, onSelect, disabled = false, children })=>/*#__PURE__*/ React.createElement("select", {
        className: styles.select,
        value: value,
        disabled: disabled,
        onChange: (event)=>onSelect(event.target.value)
    }, children);
